import { DateInputFormik } from '@strata/react-date-time';
import { TextAreaFormik, TextInputFormik } from '@strata/react-inputs';
import { RadioButtonGroupFormik } from '@strata/react-radio-button-group';
import { type FormikProps } from 'formik';

import { type PriorAuthFormValues } from 'components/intakeCases/dialogs/LogPriorAuthCommunicationDialog';

interface SubmissionAttemptFormProps {
    formik: FormikProps<PriorAuthFormValues>;
}

export const SubmissionAttemptForm = ({ formik }: SubmissionAttemptFormProps) => (
    <>
        <RadioButtonGroupFormik
            name="isPriorAuthSubmitted"
            label="Prior Auth Submitted?"
            required
            onChange={(value) => {
                void formik.setFieldValue('isPriorAuthSubmitted', value === 'Yes');
            }}
            options={['Yes', 'No']}
            selectedValue={formik.values.isPriorAuthSubmitted ? 'Yes' : 'No'}
        />
        {!formik.values.isPriorAuthSubmitted && (
            <>
                <RadioButtonGroupFormik
                    name="communicationDirection"
                    label="Communication Direction"
                    required
                    options={['Inbound', 'Outbound']}
                />
                <RadioButtonGroupFormik
                    name="outreachOrganization"
                    label="Organization"
                    required
                    options={['Health Plan', 'Pharmacy', 'Prescriber']}
                />
                <RadioButtonGroupFormik
                    name="communicationType"
                    label="Communication Type"
                    required
                    options={['Fax', 'Phone']}
                />
                <DateInputFormik id="priorAuthActivityDate" label="Date" required showTime />
                <TextAreaFormik id="note" label="Note" />
            </>
        )}
        {formik.values.isPriorAuthSubmitted && (
            <>
                <RadioButtonGroupFormik
                    name="submitMethod"
                    label="Submit Method"
                    required
                    options={['Submitted via CoverMyMeds', 'Submitted via ePA']}
                />
                <TextInputFormik id="submitId" label="Submit ID" required />
                <DateInputFormik id="priorAuthActivityDate" label="Date" required showTime />
                <TextAreaFormik id="note" label="Note" />
            </>
        )}
    </>
);
